import CampaignForm from '@/pages/ads/CampaignForm.tsx';

const CreateCampaign = () => {
  return <CampaignForm mode="create" />;
};

export default CreateCampaign;

